import { useEffect, useState } from "react";

export function useLinkPreview(url: string) {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (!url) return;

    // console.log("useLinkPreview", url);

    let active = true;

    async function load() {
      try {
        const res = await fetch(
          `https://api.microlink.io/?url=${encodeURIComponent(url)}`
        );
        const json = await res.json();
        // console.log("useLinkPreview-json", json);

        if (active && json?.data) {
          setData({
            title: json.data.title,
            desc: json.data.description,
            image: json.data.image?.url,
            url,
          });
        }
      } catch (err) {
        console.log("[Preview] erro:", err);
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [url]);

  return data;
}
